import React from 'react';
import PropTypes from 'prop-types';

import themeable from 'zignal-landscape/lib/themeable';
import FilterIcon from 'zignal-landscape/lib/Icon/FilterIcon';
import Card from 'zignal-landscape/lib/Card';

import filterDescription from 'zignal-widgets/lib/filterDescription';
import ToolTip from 'zignal-landscape/lib/ToolTip';

const SmartFilterSummary = ({
  styles,
  smartFilter,
  isExpandedVersion = false
}) => {
  const liElClass = isExpandedVersion ? styles.itemTitle : styles.itemTitleCollapsed;
  const smartFilterList = filterDescription(smartFilter.headerInfo, liElClass, isExpandedVersion);

  const tooltipHtml = <div className={styles.tooltipHtml}>{smartFilterList}</div>;

  return isExpandedVersion
    ? (
      <div>
        <p className={styles.mainTitle}>
          <FilterIcon /> Smart Filter Summary
        </p>
        <Card>
          <div className={styles.smartFilterListExpanded}>
            {smartFilterList}
          </div>
        </Card>
      </div>
    ) : (
      <span className={styles.smartFilterSummaryCollapsed}>
        <span className={styles.iconContainer}>
          <FilterIcon width={20} height={20} />
        </span>
        <span className={styles.mainTitleCollapsed}>{smartFilter.filterName}</span>
        |
        <ToolTip
          position="bottom"
          width={550}
          tooltipText={tooltipHtml}
        >
          <span className={styles.tooltipChildren}>
            {smartFilterList}
          </span>
        </ToolTip>
      </span>
    );
};

SmartFilterSummary.propTypes = {
  styles: PropTypes.object.isRequired,
  smartFilter: PropTypes.object.isRequired,
  isExpandedVersion: PropTypes.bool
};

export default themeable(SmartFilterSummary);
